import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import ReactSelect from "../../UI/ReactSelect";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import InputMask from "react-input-mask";


export default function Edit(props) {
  const {
    onHide,
    show,
    merchant,
    onMerchants,
    skip,
    take,
    sortField,
    orderBy,
    partners,
    cities,
    setCities,

    // assets,
  } = props;
  const { id, firstName, lastName, email, phone, partnerId, partnerCityId } = merchant;
  const [isError, setIsError] = useState("");

  const [partnersOptions, setPartnersOptions] = useState([]);
  const [partnersOption, setPartnersOption] = React.useState(null);

  const [citiesOptions, setCitiesOptions] = React.useState([]);

  const [citiesOption, setCitiesOption] = React.useState(null);




  useEffect(() => {
    setPartnersOptions(
      partners.map((suggestion) => ({
        value: suggestion.id,
        label: suggestion.name,
      }))
    );
  }, [partners]);


  useEffect(() => {
    setCitiesOptions(
      cities?.map((suggestion) => ({
        value: suggestion.id,
        label: suggestion.address,
      }))
    );
  }, [cities]);

  function handleChangePartner(value, setFieldValue) {
    setPartnersOption((prevState) => value);
    setFieldValue("partnerId", value.value);

    axios
      .get(`${process.env.REACT_APP_API_URL}partner/cities/${value?.value}`)
      // .then((res) => {
      //   const displayTypesNames = res?.data?.data?.map(({ id, address }) => ({
      //     value: id,
      //     label: address,
      //   }));
      //   setCities(displayTypesNames);
      // });
      .then(({ data: { data } }) => {
        setCities(data);
      });
    setCitiesOption(null);
  }

  function handleChangeCities(value, setFieldValue) {
    // setCitiesOption(value);
    setCitiesOption((prevState) => value);
    setFieldValue("partnerCityId", value?.value);

  }


  const onPutMerchant = (values, resetForm, setSubmitting) => {
    const merchant = {
      id: id,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.phone,
      partnerId: values.partnerId,
      partnerCityId: values.partnerCityId,

    };
    axios
      .put(`${process.env.REACT_APP_API_URL}partner/merchant`, merchant, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onMerchants(skip, take, sortField, orderBy);
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const EditSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string().required("Email is required")
      .email("Wrong email format. E.g. jhon.doe@example.com")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
    ,
    phone: Yup.string().required("Phone is required"),
    partnerId: Yup.string().required("Partner Id is required"),
    partnerCityId: Yup.string().required("Partner City Id is required"),

  });

  const getInputClasses = (touched, errors, fieldName) => {
    if (touched[fieldName] && errors[fieldName]) {
      return true;
    }
    if (touched[fieldName] && errors[fieldName]) {
      return false;
    }

    return false;
  };



  useEffect(() => {
    setPartnersOption((prev) =>
      partnersOptions.find((option) => option.value === partnerId)
    );
  }, [partnerId, partnersOptions]);

  useEffect(() => {
    setCitiesOption((prev) =>

      citiesOptions?.find((option) => option.value === partnerCityId)
    );
  }, [partnerCityId, citiesOptions]);

  // useEffect(() => {
  // }, [assetsOption, assetId]);
  useEffect(() => { }, [partnersOption, partnerId]);
  useEffect(() => { }, [citiesOption, partnerCityId]);


  useEffect(() => {
    if (!show) {
      // setAssetsOption(null);
      setPartnersOption(null);
      setCitiesOption("")

    }
  }, [show]);


  return (
    <Modal
      onHide={onHide}
      show={show}
      size="sm"
      aria-labelledby="edit"
      className="modal-right pr-0"
    >
      {merchant &&
        Object.keys(merchant).length !== 0 &&
        merchant.constructor === Object && (
          <Formik
            initialValues={{
              firstName: firstName,
              lastName: lastName,
              email: email,
              phone: phone,
              partnerId: partnerId,
              partnerCityId: partnerCityId,

            }}
            validationSchema={EditSchema}
            onSubmit={(values, { resetForm, setSubmitting }) => {
              onPutMerchant(values, resetForm, setSubmitting);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              handleChange,
              handleBlur,
              resetForm,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title id="edit">Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="col-12 pl-4 pr-4">
                    <div className="row">

                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="firstName"
                            label="First name"
                            placeholder="First name"
                            className="w-100"
                            value={values.firstName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(
                              touched,
                              errors,
                              "firstName"
                            )}
                          />
                        </div>
                        {touched.firstName && errors.firstName ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.firstName}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="lastName"
                            label="Last name"
                            placeholder="Last name"
                            className="w-100"
                            value={values.lastName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "lastName")}
                          />
                        </div>
                        {touched.lastName && errors.lastName ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.lastName}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="email"
                            label="Email"
                            placeholder="Email"
                            className="w-100"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "email")}
                          />
                        </div>
                        {touched.email && errors.email ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.email}</div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          {/* <TextField
                            id="phone"
                            label="Phone"
                            placeholder="Phone"
                            className="w-100"
                            value={values.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "phone")}
                          /> */}
                          <InputMask
                            mask="\9\94999999999"
                            value={values.phone}
                            // onChange={(e) => handleChangePhoneNumber(e)}
                            onChange={handleChange}
                            disabled={false}
                            maskChar=""
                            id="phone"
                            type="number"
                          >
                            {() =>
                              <TextField
                                label="Phone number"
                                placeholder="Phone number"
                                className="w-100"
                                name="phone"
                              // onKeyDown={handleEnter}

                              // error={getInputClasses("phone")}
                              // {...formik.getFieldProps("phone")}
                              />}
                          </InputMask>
                        </div>
                        {touched.phone && errors.phone ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.phone}</div>
                          </div>
                        ) : null}

                      </div>


                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">

                          <input
                            type="hidden"
                            id="id"
                            name="id"
                            value={values.id}
                          />
                          <ReactSelect
                            suggestions={partnersOptions}
                            handleChangeSingle={(value) =>
                              handleChangePartner(value, setFieldValue)
                            }
                            single={partnersOption}
                            label="Partner Id"
                            placeholder="Partner Id"
                            inputId="partnerId"
                            error={getInputClasses(touched, errors, "partnerId")}
                          />
                        </div>
                        {touched.partnerId && errors.partnerId ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.partnerId}
                            </div>
                          </div>
                        ) : null}

                      </div>


                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="partnerCityId"
                            name="partnerCityId"
                            label="City id"
                            placeholder="City id"
                            className="w-100"
                            type="number"
                            hidden
                            error={getInputClasses("partnerCityId")}
                          // {...formik.getFieldProps("partnerCityId")}
                          />

                          <ReactSelect
                            suggestions={citiesOptions}
                            // handleChangeSingle={handleChangeCities}
                            handleChangeSingle={(value) =>
                              handleChangeCities(value, setFieldValue)
                            }
                            single={citiesOption}
                            label="Choose city"
                            placeholder="Choose city"
                            inputId="partnerCityId"
                            error={getInputClasses(touched, errors, "partnerCityId")}

                          />
                        </div>


                        {touched.partnerCityId && errors.partnerCityId ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.partnerCityId}
                            </div>
                          </div>
                        ) : null}
                        {isError && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block MuiFormLabel-root Mui-error">
                              {isError}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="light"
                    onClick={() => {
                      onHide(false);
                      resetForm();
                    }}
                  >
                    Close
                  </Button>
                  <Button type="submit">Edit</Button>
                </Modal.Footer>
              </form>
            )}
          </Formik>
        )}
    </Modal>
  );
}
